// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__4Rlfy","pageGrid":"styles_pageGrid__72Xno","header":"styles_header__AGS0a"};